<template>
    <v-navigation-drawer v-model="drawer" absolute app temporary>
        <v-list-item>
            <v-list-item-avatar>
                <v-img src="../../assets/default-avatar.jpg"
                       alt="Profile image"/>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>{{ $store.getters.userName }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
                <v-btn icon @click="$router.push({name: 'profile'})">
                    <v-icon>mdi-settings</v-icon>
                </v-btn>
            </v-list-item-action>
        </v-list-item>

        <v-divider/>

        <v-list dense nav>
            <v-list-item link to="/">
                <v-list-item-icon>
                    <v-icon>mdi-home-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/change_log">
                <v-list-item-icon>
                    <v-icon>mdi-format-list-text</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Change Log</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-divider class="mt-6 mb-2"/>

            <v-list-item link @click="signOut">
                <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Sign out</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
  import AuthService from "../../services/AuthService";
  import UserService from "../../services/UserService";

  export default {
    data: () => ({
      drawer: null
    }),

    beforeMount() {
      if (this.$store.getters.userId) {
        UserService.view(this.$store.getters.userId)
          .then(response => {
            this.$store.dispatch("setUser", response.data.data);
          });
      }
    },

    methods: {
      async signOut() {
        this.drawer = false;
        await AuthService.logout()
          .then(() => {
            this.emptyStore();
          })
          .catch(() => {
            this.emptyStore();
          });
      },

      emptyStore() {
        this.$store.dispatch("clearUser");
        this.$router.push({
          name: "signin"
        });
      },

      toggleDrawer() {
        this.drawer = !this.drawer;
      }
    }
  };
</script>
